/**
 * getAnimatableEndEvent
 *
 * returns the name of transitionend/animationend event for cross browser compatibility
 *
 * @param {string} type of the animatableEvent: 'transition' or 'animation'
 * @returns {string} the transitionend/animationend event name
 */
const getAnimatableEndEvent = function whichAnimationType(type) {
  let animatableEvent;

  const el = document.createElement('fakeelement');
  const capitalType = capitalize(type);

  const animations = {
    [type]: `${type}end`,
    [`O${capitalType}`]: `o${capitalType}End`,
    [`Moz${capitalType}`]: `${type}end`,
    [`Webkit${capitalType}`]: `webkit${capitalType}End`,
    [`MS${capitalType}`]: `MS${capitalType}End`,
  };

  const hasEventEnd = Object.keys(animations).some(item => {
    if (el.style[item] !== undefined) {
      animatableEvent = animations[item];
      return true;
    }

    return false;
  });

  if (!hasEventEnd) {
    throw new Error(`${type}end is not supported in your web browser.`);
  }

  return animatableEvent;
};

/**
 * scrollTop
 *
 * gets/sets the current vertical position of the scroll bar for the element
 * @param {HTMLElement} el
 * @param {number} position
 * @returns {number|undefined}
 */
/* eslint-disable no-param-reassign */
const scrollTop = function scrollTop(el = window, position) {
  // getting the scroll position
  if (!position) {
    if (el === window || el === document) {
      return (
        window.scrollY ||
        window.pageYOffset ||
        document.body.scrollTop +
          (document.documentElement && document.documentElement.scrollTop)
      );
    }

    return el.scrollTop;
  }

  // otherwise, setting the scroll position
  if (el === window || el === document) {
    if (document.documentElement) {
      document.documentElement.scrollTop = position;
    }
    document.body.scrollTop = position;
  } else {
    el.scrollTop = position;
  }

  return undefined;
};

/**
 * offset
 *
 * the vanilla JS equivalent of jQuery.offset()
 * @url https://github.com/oneuijs/You-Dont-Need-jQuery#2.3
 * @param el
 * @returns {{top: number, left: number}}
 */
const offset = function offset(el) {
  const box = el.getBoundingClientRect();

  return {
    top: box.top,
    left: box.left,
  };
};

export { getAnimatableEndEvent, scrollTop, offset };

// @TODO:10 separate this function from this file
function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
